export const getIsFormValid = state =>
  state.membership.updateCustomer.get('fields').every(field => field.get('touched') && !field.get('error'));

export const getUser = state =>
  state.membership.updateCustomer.get('fields')
    .reduce((result, field) => {
      const user = { ...result };
      user[field.get('id')] = field.get('value') || '';
      return user;
    }, {});

export const isSuccess = state => state.membership.updateCustomer.get('isSuccess');



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/selectors.js